module.exports = __webpack_public_path__ + "img/grass-g075478bd2_1920.8e7fcf67.jpeg";